import { AreaDto } from './area.dto';
import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { BusinessEntityDto } from './businessEntity.dto';
import { CostCentreDto } from './costCentre.dto';
import { MerchantTypeDto } from './merchantType.dto';
import { PaymentMethodDto } from './paymentMethod.dto';

export class MerchantGroupDto extends BaseDto {
  name: string;
  areas?: AreaDto[];
  costCentres?: CostCentreDto[];
  brands?: BrandDto[];
  merchantTypes?: MerchantTypeDto[];
  merchantBusinessEntities?: BusinessEntityDto[];
  paymentMethods?: PaymentMethodDto[];
  merchantGroupLink?: string;
  isRaiMember?: boolean;
  raiMembershipNumber?: string;
}
